import React, { Component } from "react";
import Card from "react-bootstrap/Card";
import {
  Button,
  Container,
  Row,
  Col,
  Form,
} from "react-bootstrap";

import { connect } from "react-redux";
import { Dispatch } from "redux";
import "antd/dist/antd.css";
import "./CheckIn.scss";
import { ICheckInProps, ICheckInState } from "../../interfaces/checkin";
import { IRootState } from "../../interfaces";
import { DatePicker } from "antd";
import moment from "moment";
import { getCheckinDateRequest, checkInSubmitRequest, getMotivationRequest, getTopVideosRequest} from '../../action';
import { topVideosReducer } from "../../reducer/TopVideos";
import { AppRoutes, FrontendUrl } from "../../config";
import Loader from "../../components/Loader/Loader";
import noImage from "../../assets/images/no-image.png";


const weekFormat = "DD/MM";
var disabledButtonsDailyCheckIn: any[] = [];
var disabledButtonsFacilitationCheckIn: any[] = [];
var weekDaysList: any[] = [];
var weekDates: any[] = [];
var attendanceTypeName: any[] = [
  "Daily Scrum",
  "Sprint Planning",
  "Backlog Refinement",
  "Knowledge Share",
  "Sprint Review",
  "Sprint Retrospective",
  "Training",
  "Backlog Refinement 2",

  "CoP Meeting",
  "Scrum of Scrum",
  "Ad-Hoc Meeting",
];

var endOfWeek = moment().endOf("week").toDate();
console.log(endOfWeek, ">>>>>>>>>>>>>>>>>>>End of Week");
let currentDate;
var nextDate: any;
// dates
// var currentTime = new Date();
// console.log(currentTime, "enddd")

// function disabledDate(current) {
//   // Can not select days before today and today
//   return current && current.valueOf() < Date.now();
// }

class CheckIn extends Component<ICheckInProps, ICheckInState> {
  constructor(props: ICheckInProps) {
    super(props);
    this.state = {
      CheckInDataFaciliation: [],
      checkDate: "",
      CheckInDataAttendance: [],
      DropDownValue: "",
      showSelectDate: "",
      SelectedDate: "",
      startDate: "",
      endDate: "",
      countdownDate: 0,
      datapickerToggle: false,
      topVideosList: [],
      playHomeVideo: "",
    };
  }

  // week days getter function
  getThisWeekDates = () => {
    for (var i = 1; i <= 6; i++) {
      weekDates.push(moment().day(i));
    }
    console.log("here here", weekDates);
    return weekDates;
  };

  checkboxValueIntializer = () => {
    for (let i = 0; i <= attendanceTypeName.length - 1; i++) {
      this.state.CheckInDataFaciliation[i] = 0;
      this.state.CheckInDataAttendance[i] = 0;
    }
  };

  componentDidMount() {
    this.getCountDate();
    this.setState({ checkDate: this.getCurrentDateString() });
    this.setState({ showSelectDate: "none" });
    this.checkboxValueIntializer();

    var thisWeekDates: any = this.getThisWeekDates();

    weekDaysList = [];
    thisWeekDates.forEach((date: any) => {
      weekDaysList.push(date.format());
    });
    console.log("weeeeeeeeeeeeeeeeeeeeee", weekDaysList);

    const { getMotivationData, getTopVideos } = this.props;
    console.log("-------------------------------",this.props)
    var startenddates = this.getMonday();
    const data = {
      startenddates,
    };
    console.log("startenddtes",data);
    getMotivationData(data);
    getTopVideos();
    
  }

  getNextMonday() {
    const now = new Date()
    const today = new Date(now)
    const nextMonday = new Date(today)

    do {
      nextMonday.setDate(nextMonday.getDate() + 1) // Adding 1 day
    } while (nextMonday.getDay() !== 1)

    console.log(nextMonday);
    return nextMonday;
  }

  getMonday() {    
    const format2 = "YYYY-MM-DD";
    var date2 = new Date();
    //var date2 = this.getNextMonday();
    
    var firstday = new Date(date2.setDate(date2.getDate() - date2.getDay() + 1)).toUTCString();
    var lastday = new Date(date2.setDate(date2.getDate() - date2.getDay() + 7)).toUTCString();
    

    let startDay = moment(firstday).format(format2);
    let endDay = moment(lastday).format(format2);
    return startDay+" : "+endDay;
  }

  dropDownHider = () => { 
    if(document.getElementById("AttendanceDropDownContainer")?.style.display === "none") {
      document.getElementById("AttendanceDropDownContainer")?.setAttribute("style","display:block");
    } else {
      document.getElementById("AttendanceDropDownContainer")?.setAttribute("style","display:none");
    }
    if(this.state.datapickerToggle) {
      this.setState({
        datapickerToggle: !this.state.datapickerToggle,
      });
    }
  };

  handleChange = (event: React.ChangeEvent<HTMLInputElement>,num: number ) => {
    const { name, value, type } = event.target;
    if (type === "checkbox") {
      const { checked } = event.target;
      this.setState({
        ...this.state,
        [name]: checked,
      });
    } else {
      this.setState({
        ...this.state,
        [name]: value,
      });
    }    
    let eventStatus;
    let FacilitationeventStatus;
    if(name.indexOf("attendance") !== -1){
      eventStatus = (event.target.checked === true)  ? "1" : "0";
      for(let i=0; i<attendanceTypeName.length; i++) {
        if(i === num) {
          disabledButtonsDailyCheckIn[num] = eventStatus;
        } else {
          if(this.state.CheckInDataAttendance.length === 0) {
          disabledButtonsDailyCheckIn[i] = 0;
          } else {
            for(let j=0; j<this.state.CheckInDataAttendance.length; j++ ) {
              if(j !== num){
                disabledButtonsDailyCheckIn[j] = this.state.CheckInDataAttendance[j];
              }
            }              
          }
        }
      }
    this.setState({
      CheckInDataAttendance: disabledButtonsDailyCheckIn,
    });
    }
    if(name.indexOf("facilitate") !== -1){
      FacilitationeventStatus = (event.target.checked === true)  ? "1" : "0";
      for(let i=0; i<attendanceTypeName.length; i++) {
        if(i === num) {
          disabledButtonsFacilitationCheckIn[num] = FacilitationeventStatus;
        } else {
          if(this.state.CheckInDataFaciliation.length === 0) {
            disabledButtonsFacilitationCheckIn[i] = 0;
          }else {
            for(let j=0; j<this.state.CheckInDataFaciliation.length; j++ ) {
              if(j !== num){
              disabledButtonsFacilitationCheckIn[j] = this.state.CheckInDataFaciliation[j];
              }
            }
          }
        }
      }
    //console.log("disabledButtonsFacilitationCheckIn",disabledButtonsFacilitationCheckIn);
    this.setState({
      CheckInDataFaciliation: disabledButtonsFacilitationCheckIn,
    });  
    }
    
  };

  getCurrentDateString = () => {
    const format2 = "YYYY-MM-DD";
    var date2 = new Date();

    let dateTime1 = moment(date2).format(format2);
    return dateTime1;
  };
  // SUBMIT BUTON CLICKED
  submitCheckIn = () => {  
    disabledButtonsDailyCheckIn = this.state.CheckInDataAttendance ;
    disabledButtonsFacilitationCheckIn = this.state.CheckInDataFaciliation ;   

    let facilitation = this.state.CheckInDataFaciliation;
    let attendance = this.state.CheckInDataAttendance;
    let checkDate = this.state.checkDate;
    let checkinType = this.state.DropDownValue;
    console.log(
      "facilitation\n" +
        facilitation +
        "\n" +
        "Daily Check In \n" +
        attendance +
        "\n" +
        "checkDate\n" +
        checkDate
    );
    let checkinTypeRef = 1;
    const { submitCheckInData } = this.props;

    const data = {
      facilitation,
      attendance,
      checkDate,
      checkinTypeRef    };
    
    submitCheckInData({ ...data });
    this.setState({ DropDownValue: "" });
  };
  closeDiv = () => {
    this.setState({ DropDownValue: "" });
    // console.log('i clickeddddddddddd')
  };

  getCountDate() {
    const msInDay = 24 * 60 * 60 * 1000;
    currentDate = Math.round(
      Math.abs(new Date().getTime() - new Date("2022-07-10").getTime()) /
        msInDay
    );
    this.setState({
      countdownDate: currentDate,
    });
    console.log("current Date--",currentDate);
  }

  getEventsDaywise = (date: any) => {  
    let selecteddate = date;
    let endDate = date;
    const { getCheckinDate } = this.props;
    console.log("-------------------------------",this.props)
    const data = {
      selecteddate,
    };
    this.setState({
      checkDate: date,
    });
    //console.log("selectedDay",data);
    getCheckinDate({ ...data });
  }

  componentDidUpdate(prevProps: ICheckInProps) {
  const { checkInReducer} = this.props;
  const { checkInData } = checkInReducer;
  const {motivationReducer} = this.props;
  const {topVideosReducer} = this.props;
  if (prevProps.topVideosReducer !== this.props.topVideosReducer) {
    const {displayVideos} = topVideosReducer;
    //console.log("displayVideos", topVideosReducer.displayVideos.length);
    var topVideos = [];
    var playVideo;
    for(var i=0;i<topVideosReducer.displayVideos.length;i++) {
      //console.log("top videos",displayVideos[i]);
      if(i === 0 ) {
        playVideo = displayVideos[i];
      } else {
        topVideos.push(displayVideos[i])
      } 
    }
    this.setState({playHomeVideo: playVideo});
    this.setState({topVideosList: topVideos});
  }

    if (
      motivationReducer &&
      motivationReducer.motivationData &&
      Object.entries(motivationReducer.motivationData).length && prevProps.motivationReducer !== this.props.motivationReducer
    ) {
      const { motivationData } = motivationReducer;
      //console.log("MondayMotivation", motivationData.motivation); 
    }

  if (prevProps.checkInReducer !== this.props.checkInReducer) {
    let attendanceArr;
    let facilitateArr;
    if ( !checkInReducer.isError &&
      checkInReducer &&
      checkInReducer.checkInData 
    ) { 
          attendanceArr = (checkInData.attendance).split(",");
          facilitateArr = (checkInData.facilitation).split(",");
          this.setState({
            CheckInDataAttendance: attendanceArr,            
            CheckInDataFaciliation: facilitateArr,
            DropDownValue: "DailyCheckIn",
          });
        /*}else {
          this.setState({
            DropDownValue: "",
            CheckInDataAttendance: [],
            CheckInDataFaciliation: [],
          });
        }   */ 
    } else if(checkInReducer.isError) {
      this.setState({
        DropDownValue: "",
        CheckInDataAttendance: [],
        CheckInDataFaciliation: [],
      });
    }
  }
  }

  ChangeVideo = (item: any) => {
    let input = document.getElementById(`Viddeo-${item.id}`);
    if (input) {
      (input as HTMLVideoElement).pause()
    }
    this.props.history.push(
      AppRoutes.MY_VIDEOS_VIEW.replace(
        ":id",
        item.id,

      )
    )

  }



  render() { 
    const { motivationReducer} = this. props;
    const { motivationData } = motivationReducer;
    const {topVideosReducer} = this.props;
    const {displayVideos} = topVideosReducer;

    return (
      <>
        <div className="main-section module-custom-main" id="right-container">
          <Container fluid>
          <Row>
              <Col
                xs={12}
                md={8}
                sm={12}
                className="welcomeSection"
              >
                <div>
                  <h3>Welcome back, {localStorage.getItem("firstName")}</h3>
                  <p style={{ width: "326px" }}>
                    On this side of the portal you will find your metrics and
                    progress. But first let's check you in...
                  </p>
                </div>  
                <div className="main-section-checkin" >
                  <div className="d-flex flex-column">
                    <div className="p-2 col-example" style={{padding:"5px !important"}}>
                      <h4 style={{ color: "white", padding: "10px", paddingLeft: "6px" }}>
                        Today's Check In
                      </h4>
                    </div>
                    <div
                      className="d-flex  flex-sx-column"
                      style={{ height: "80px" }} id="main-section-checkin"
                    >
                      <div className="col-md-4 col-sm-12 col-12">
                      <Container>
                        <div>
                          <p className="checkinLabel"
                          >
                            Select Date
                          </p>
                        </div>
                        <DatePicker format="DD-MM-YY"
                          onClick={() => {
                            this.setState({
                              datapickerToggle: !this.state.datapickerToggle,
                            });
                          }}
                          onChange = {()=>{
                            this.setState({
                              datapickerToggle: !this.state.datapickerToggle,
                            });
                          }}
                          open={this.state.datapickerToggle}
                          disabledDate={(current) => {
                            // Can not select days after today and before start Date
                            const start = moment().subtract(1, "w");
                            return current < start || current > moment();
                          }}
                          style={{
                            background: "white",
                            width: "100%",
                            height: "44px",
                            borderRadius: "10px",
                            borderLeftWidth: 0,
                            borderRightWidth: 0,
                            borderTopWidth: 0,
                            marginLeft:"20px",
                          }}
                          onSelect={(date) => {
                            // console.log('date added',date.format("YYYY-MM-DD HH:mm:ss"))
                            console.log("Date Selected>>>", date);
                            this.setState({
                              checkDate: date.format("YYYY-MM-DD HH:mm:ss"),
                            });
                            this.setState({
                              SelectedDate: date.format("YYYY-MM-DD HH:mm:ss"),
                            });
                            this.dropDownHider();
                            this.getEventsDaywise(date.format("YYYY-MM-DD HH:mm:ss"));

                          }}
                        />
                        </Container>
                      </div>
                      <div className="col-md-6 col-sm-12 col-12">
                        <Container>
                          <div>
                            <p id="DCheckinTop"                             
                            style={{
                              margin: "0px",
                              fontSize: "18px",
                              color: "white",
                              marginLeft: "10px",
                              }}
                            >
                              Daily Check In
                            </p>
                          </div>                                     
                                     
                         
                            <div className="checkin-picker checkin-picker-focused" style={{background: "white", width: "100%", height: "44px", borderRadius: "10px",borderLeftWidth: "0px", borderRightWidth: "0px",borderTopWidth: "0px", marginLeft: "5px"}}
                             onClick={() => {
                              this.dropDownHider();
                              }}
                            >
                              <div className="checkin-picker-input">
                                <span style={{
                                    background: "white",
                                    width: "100%",
                                    height: "44px",
                                    borderRadius: "10px",
                                    color: "#cec7c7",
                                  }}
                                >Click to select activity<i className="far fa-arrow-alt-circle-down" style={{color:"gold", float:"right", paddingTop: "5px"}} aria-hidden="true"></i></span>
                               
                                  </div></div>
                       


                            <div
                              style={{ marginLeft: "15px", display:"none" }}
                              id="AttendanceDropDownContainer"
                            >
                              
                              <Row>
                                <Col>

                                <div className="Eventspopup">
                                  <div>
                                          <Row>
                                            <Col
                                              style={{
                                                float: "right",
                                                paddingLeft: "7px",
                                              }}>
                                               <Row className="CheckInsection1" style={{marginLeft: "10px" , marginRight:"20px"}}>
                                               <Col lg={6}className="col-md-6 col-sm-6 col-6"  ></Col><Col lg={3} className="col-md-3 col-sm-3 col-3" style={{fontWeight:"bold"}}>Attended</Col><Col lg={3} className="col-md-3 col-sm-3 col-3" style={{fontWeight:"bold"}}>Facilitated</Col></Row>
                                                
                                                </Col> </Row>
                                              </div>
                                  {attendanceTypeName.map(
                                    (item: any, index: any) => {
                                      return (
                                        <div>
                                          <Row>
                                            <Col
                                              style={{
                                                paddingRight: "0",
                                                paddingLeft: "7px",
                                              }}
                                            >
                                              <Row className="CheckInsection" style={{marginLeft: "10px" , marginRight:"20px"}}>
                                                <Col lg={6} className="col-md-6 col-sm-6 col-6"  >
                                                  <span className="CheckInText">
                                                    {item}
                                                  </span>
                                                </Col>
                                                <Col lg={3} className="col-md-3 col-sm-3 col-3"  >                                                 
                                                  <Form.Check
                                                  custom
                                                  type="checkbox"
                                                  name={`attendance-${index}`}
                                                  checked={ this.state.CheckInDataAttendance[index] === "1"? true : false }
                                                  onChange={event => this.handleChange(event, index)}
                                                  id={`attendance-${index}`}
                                                  style={{paddingLeft:"2.5rem"}}
                                                />
                                                </Col>
                                                <Col lg={3} className="col-md-3 col-sm-3 col-3"  >  
                                                <Form.Check
                                                  custom
                                                  type="checkbox"
                                                  name={`facilitate-${index}`}
                                                  checked={ this.state.CheckInDataFaciliation[index] === "1"? true : false }
                                                  onChange={event => this.handleChange(event, index)}
                                                  id={`facilitate-${index}`}
                                                  style={{paddingLeft:"2.5rem"}}
                                                />
                                                </Col>
                                              </Row>
                                            </Col>
                                          </Row>
                                        </div>
                                      );
                                    }
                                  )}
                                </div>  
                                
                                </Col>
                              </Row>
                                                         
                              </div>     
                        </Container>
                      </div>  
                      <div
                      className="col-md-2 col-sm-12 col-12"                    
                    >
                      <span>
                        <Button
                          disabled={this.state.SelectedDate === ""}
                          onClick={this.submitCheckIn}
                          id="checkinbtn"
                          style={{
                            //marginRight: "100px",
                            marginTop: "32px",
                            color: "white",
                            background: "gray",
                            borderColor: "gray",
                            fontWeight: "bold",
                            borderRadius: "5px",
                            boxShadow: " 2px gray",
                            fontFamily: "Lokem-Headings-Robo",                            
                            marginLeft: "-12px",
                          }}
                          variant="warning"
                        >
                          Check-in
                        </Button>
                      </span>
                    </div>                    
                    </div>
                    
                  </div>
                </div>              
              </Col>
              <Col
                xs={12}
                md={4}
                sm={12}
                style={{ background: "rgb(245, 245, 245)" }}
              >
                <div className="MMHeight">
                  <div
                    style={{
                      overflow: "hidden",
                      marginTop: "25px",
                      background: "white",
                      borderRadius: "10px",
                      boxShadow: "#efefef 0px 10px 0px",
                      height: "125px",
                    }}
                  >
                    <div style={{ textAlign: "center" }}>
                      <p
                        style={{
                          fontSize: "20px",
                          fontWeight: "bold",
                          marginBottom: "10px",
                          color: "#c8a328",
                        }}
                      >
                        Monday Motivation
                      </p>
                    </div>
                    <div
                      style={{
                        textAlign: "center",
                      }}
                    >
                      <p
                        style={{
                          textAlign: "left",
                          paddingLeft: "2px",
                        }}
                      >
                        <b>" </b>{motivationData.motivation}
                        <b> "</b>
                      </p>
                    </div>
                  </div>                  
                </div>
                <div>                  
                  <div style={{ marginTop: "10px" }}>
                    <Card
                      
                      className="countdown-card countdown-card-ht ml-auto p-2 col-example"
                    >
                      <Card.Body className="d-flex bd-highlight mb-3 example-parent flex-column">
                        <Card.Text className="countdown-section-days align-self-center p-2 bd-highlight col-example">
                          {this.state.countdownDate}
                          <sub className="countdown-section-sub ">days</sub>
                        </Card.Text>
                        <Card.Text className="countdown-section-sub align-self-center p-2 bd-highlight col-example">
                          Until your subscription ends
                        </Card.Text>
                        <Button
                          className="countdown-section-btn align-self-center p-2 bd-highlight col-example"
                          type="button"
                          // onClick={this.addDays}
                        >
                          Renew Now
                        </Button>
                      </Card.Body>
                    </Card>
                  </div>
                </div>
              </Col>
            </Row>
            <Row>
              <Col
                xs={12}
                md={6}
                sm={12}
                style={{
                  marginBottom: "10px",
                  padding: "0px",
                }}  
                className="v-sec-padding"              
              > 
              <div className="videoContainer">
                <div style={{ textAlign: "center", paddingTop:"15px" }}>
                  <h3 style={{ fontWeight: "bold" }}>
                    Top 5 Trending Videos
                  </h3>
                </div>
                {this.state.playHomeVideo ? (
                <div className="mySlides" style={{boxSizing: "initial",  width:"100%"}}>
                   <video controlsList="nodownload" 
                      controls
                      autoPlay={false}
                      playsInline
                      src={`${FrontendUrl}${this.state.playHomeVideo.url}`}
                      style={{objectFit:"cover", boxSizing: "initial", borderRadius: "5px", width:"100%"}}
                      poster={`${FrontendUrl}${this.state.playHomeVideo.thumbnailUrl}`}></video>
                </div>) : ("")}  
                <div className="caption-container">
                  <div className="row1">
                {!this.state.topVideosList  ? (
                  <Loader />
                ) : (
                  this.state.topVideosList.map((item: any, index: any) => (
                
                    <div className={`column${index}`} onClick={() => {
                      this.ChangeVideo(item); 
                    }}>
                      {item.thumbnailUrl ? (
                      <img className="demo cursor" src={`${FrontendUrl}${item.thumbnailUrl}`} style={{borderRadius: "5px",width:"100%", height:"45px"}}  alt=""/>
                      ) : (
                        <img src={noImage} alt=""
                        className="demo cursor"
                        style={{borderRadius: "5px",width:"100%"}}
                        />
                      )}
                    </div>
                  ))
                )}                 
                 </div>
                </div>
              </div>
              </Col>


                <Col>

                <div className="dboard" style={{ paddingLeft: "45px", paddingTop: "20px", float: "left"}}>                  
                  <div className="Div1" style={{ fontWeight: "600", fontSize: "14px", textAlign: "center", verticalAlign: "top", height: "50px", width: "100%",fontFamily: "Lokem-Headings-Robo" }}>
                    Modules Completed
                  </div>
                  <div style={{ textAlign: "center", verticalAlign: "top", width: "100%"}}>
                    <i className="fas fa-layer-group" style={{fontSize:"100px"}}></i>  
                  </div>
                  <div style={{ fontWeight: "bold", fontSize: "30px", textAlign: "center", height: "50px", width: "100%", paddingTop: "30px" }}>
                    12/25
                  </div>
                </div>

                </Col>


                 <Col>

                <div className="dboard" style={{ paddingLeft: "45px", paddingTop: "20px", float: "left"}}>                  
                  <div className="Div1" style={{ fontWeight: "600", fontSize: "14px", textAlign: "center", verticalAlign: "top", height: "50px", width: "100%",fontFamily: "Lokem-Headings-Robo" }}>
                    My Attendance
                  </div>
                  <div style={{ textAlign: "center", verticalAlign: "top", width: "100%" }}>
                    <i className="fas fa-tasks" style={{fontSize:"100px"}}></i>   
                  </div>
                  <div style={{ fontWeight: "bold", fontSize: "30px", textAlign: "center", height: "50px", width: "100%", paddingTop: "30px" }}>
                    89%      
                  </div>
                </div>

                </Col>
 <Col>

                <div id="avgScore" className="dboard" style={{ paddingLeft: "45px", paddingTop: "20px", float: "left",marginBottom: "25px"}}>                  
                  <div id="avgScoreDiv1" className="Div1" style={{ fontWeight: "600", fontSize: "14px", textAlign: "center", verticalAlign: "top", height: "50px", width: "100%",fontFamily: "Lokem-Headings-Robo" }}>
                    My Average Quiz Score
                  </div>
                  <div style={{ textAlign: "center", verticalAlign: "top", width: "100%" }}>
                    <i className="far fa-star" style={{fontSize:"100px"}}></i>  
                  </div>
                  <div style={{ fontWeight: "bold", fontSize: "30px", textAlign: "center", height: "50px", width: "100%", paddingTop: "30px" }}>
                    92%
                  </div>
                </div>

                </Col>




        



            </Row>
          </Container>
        </div>
      </>
    );
  }
}

const mapStateToProps: any = (state: IRootState) => ({
  checkInReducer: state.checkInReducer,
  motivationReducer: state.motivationReducer,
  topVideosReducer: state.topVideosReducer,
});

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    submitCheckInData: (data: any) => {
      dispatch(checkInSubmitRequest(data));
    },   
    getCheckinDate: (data: any) => {
      dispatch(getCheckinDateRequest(data));
    },
    getMotivationData: (data: any) => {
      dispatch(getMotivationRequest(data));
    },
    getTopVideos: () => {
      dispatch(getTopVideosRequest());
    }
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(CheckIn);
